











import { defineComponent } from '@vue/composition-api'
import ProductsFromCatalogStore from '@/store/productsList/productsFromCatalog'

export default defineComponent({
  name: 'QueryInput',
  data() {
    return {
      query: '',
    }
  },
  methods: {
    setQuery() {
      ProductsFromCatalogStore.commit('setQuery', this.query)
    },
  },
})
